import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import { Link } from 'react-router-dom';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../actions/alertActions';
import { followGroup } from '../../actions/authActions';
import { createChat } from '../../actions/chatActions';

// Light Box
import { SRLWrapper } from "simple-react-lightbox";

// Components - material UI
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';

// Icons - material UI
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import LinkIcon from '@material-ui/icons/Link';

const SportsHeader = ({ 
    setAlert,
    sport: { 
        sports_match, 
        loading 
    }, 
    auth,
    history,
    isMobile
}) => {

    // Toggle Dropdown
    const [dropdown, setDropdown] = useState(false);
    const [menuHeight, setMenuHeight] = useState(null);

    // Edit Modal toggles
    const [copied, setCopied] = useState(false);
    
    // Get the current URL and extract the "show" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");

    // Copied Modal timer logic
    useEffect(() => {
        setTimeout(() => {
            setCopied(false);
        }, 1000);
    }, [copied]);

    // Handle logic for the Copied Modal
    const toggleCopiedModal = () => {
        setDropdown(false);
        
        // setCopiedModal(!copiedModal);
        setAlert('Copied to clipboard', 'okay');
        
    }

    // Options for a component (possibly related to a slideshow or gallery)
    const options = {
        caption: {
            showCaption: false
          },
        thumbnails: {
            showThumbnails: false
        },
        buttons: {
            showAutoplayButton: false,
            showFullscreenButton: false,
            showNextButton: false,
            showPrevButton: false,
            showThumbnailsButton: false,
        }
    }
    
    return (
        <Fragment>
            {/* SRLWrapper is a lightbox for full screen image display */}
            <SRLWrapper options={options}>
                <div className="profile__header">

                    {/* Dropdown Button */}
                    <div className='profile__moreBtns'>
                        <div onClick={() => setDropdown(!dropdown)} className="profile__moreBtn">
                            <MoreHorizIcon />
                        </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className={dropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                        <div className="menu">

                            {/* Copy Link to Profile option */}
                            <CopyToClipboard 
                                text={`${process.env.REACT_APP_DOMAIN}/vs/${sports_match?._id}`}
                                onCopy={toggleCopiedModal}
                            >
                                <div className="menu-item">
                                    <LinkIcon />
                                    Copy link
                                </div>
                            </CopyToClipboard>
                            
                        </div>
                    </div>

                    {/* Overlay for the Dropdown */}
                    <div
                        className={`hidden-overlay ${dropdown ? "show" : ""}`}
                        onClick={() => setDropdown(!dropdown)}
                    />

                    {sports_match?.start_date ? (
                        <Fragment>
                            <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                                {format(sports_match.start_date, "MMM d")}
                            </span>
                            {!sports_match?.start_time_tbd ? (
                                <span style={{fontSize: '15px', color: '#636363'}}>
                                    {format(sports_match.start_date, "h:mm a")}
                                </span>
                            ) : (
                                <span style={{fontSize: '15px', color: '#636363'}}>
                                    TBD
                                </span>
                            )}
                        </Fragment>
                    ) : (
                        <span style={{fontSize: '16px', fontWeight: 600, color: '#636363'}}>
                            TBD
                        </span>
                    )}

                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        {/* Team 1 - TODOA */}
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px 16px'}}>
                            {/* Logo img */}
                            {sports_match.logo_team_1 && (
                                <div style={{height: '60px', overflow: 'hidden'}}>
                                    <img src={sports_match.logo_team_1} style={{height: '100%'}} />
                                </div>
                            )}

                            {/* Team Name */}
                            <span style={{wordWrap: 'break-word', fontSize: '18px', fontWeight: 600}}>
                                {sports_match.team_1_name}
                            </span>

                        </div>

                        <div style={{padding: '5px', display: 'flex', alignItems: 'center'}}>
                            <span style={{fontWeight: '600', fontSize: '30px'}}>{sports_match.sport_type === 'football' ? '@' : 'vs'}</span>
                        </div>

                        {/* Team 2 */}
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px 16px'}}>
                            {/* Logo img */}
                            {sports_match.logo_team_2 && (
                                <div style={{height: '60px', overflow: 'hidden'}}>
                                    <img src={sports_match.logo_team_2} style={{height: '100%'}} />
                                </div>
                            )}

                            {/* Team Name */}
                            <span style={{wordWrap: 'break-word', fontSize: '18px', fontWeight: 600}}>
                                {sports_match.team_2_name}
                            </span>

                        </div>
                    </div>

                    {/* Profile Header Tabs */}
                    <div className="profile__headerTabs">
        
                        <a href={`/vs/${sports_match?._id}`}>
                            <div className={`${(filter === null || filter === undefined || filter === 'posts') && 'active'}`}>
                                <h3>Posts</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>

                        <a href={`/vs/${sports_match?._id}?show=photos`}>
                            <div className={`${(filter && filter === 'photos') && 'active'}`}>
                                <h3>Photos</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </SRLWrapper>
        </Fragment>
    )
}

SportsHeader.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    sport: PropTypes.object.isRequired,
    // Prop type validation for function to set alerts
    setAlert: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the authentication state
    auth: state.auth,
    nav: state.nav,
    sport: state.sport
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert
})(SportsHeader);
